export default __webpack_public_path__ + "static/media/img/dp2.webp";